export default async function deleteSavedDesign(storeName,designId) {
    let response = await
        fetch(`${process.env.REACT_APP_FILE_SHARE_API}customers/customer-sections/${designId}?store_name=${storeName}`, {
            method: 'DELETE'
        })
    return await response.json()
}
